import { render, staticRenderFns } from "./QRcodeSvg.vue?vue&type=template&id=0d4e4716&scoped=true&"
import script from "./QRcodeSvg.vue?vue&type=script&lang=js&"
export * from "./QRcodeSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4e4716",
  null
  
)

export default component.exports